<template>
  <el-dialog
    class="org-channel-config-dialog"
    :visible.sync="dialogVisible"
    title="招商渠道优先级配置"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="70%"
    @close="handleCancel"
  >
    <el-table
      max-height="500"
      size="small"
      :data="currentItem.orgChannelConfigs || []"
      border
    >
      <el-table-column type="expand">
        <template #default="{ row }">
          <el-table :data="row.shops" border>
            <el-table-column label="选择" align="center" width="60">
              <template #default="{ row: childRow }">
                <el-checkbox
                  v-model="childRow.selected"
                  @change="changeRadio($event, childRow, row.shops)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              prop="departmentName"
              label="实体门店名称"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shopAddress"
              label="实体门店地址"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="departmentNo"
              label="实体门店编码"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column label="优先级" align="center" width="160">
        <template #default="{ row }">
          <el-input-number
            size="small"
            v-model="row.priority"
            :min="1"
            :precision="0"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="orgChannelName"
        label="招商渠道"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgBelongMarketClassifyName"
        label="所属事业线"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgBelongClassifySalesName"
        label="所属经销部"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgForbiddenStatusName"
        label="状态"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orgMarketManageRightCode"
        label="经营权编码"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ParentChildTableDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: this.visible, // 控制弹窗显示状态
      currentItem: {},
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    item: {
      handler(val) {
        if (!val) return (this.currentItem = {});
        this.currentItem = JSON.parse(JSON.stringify(val));
      },
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      // 校验
      let map = new Map();
      const orgChannelConfigs = this.currentItem.orgChannelConfigs || [];
      const isPassCheck = orgChannelConfigs.every((config) => {
        const hasPriority =
          config.priority !== null &&
          config.priority !== undefined &&
          config.priority > 0;
        if (!hasPriority) {
          return false;
        }
        if (map.has(config.priority)) {
          return false;
        }
        map.set(config.priority, true);
        return true;
      });

      if (!isPassCheck) {
        this.$message.error("需未每条招商渠道配置优先级且不允许重复");
        return;
      }
      this.$emit("confirm", this.currentItem);
      this.dialogVisible = false;
    },
    /**
     * 单选框改变事件
     * @param {Boolean} $event
     * @param {Object} childRow
     * @param {Array} shops
     */
    changeRadio(value, childRow, shops) {
      shops.forEach((item) => {
        item.selected = false;
      });
      childRow.selected = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.org-channel-config-dialog {
  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// orgChannelConfigDialog.vue?4bb3fe06